var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPresent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 38,
    viewBox: "0 0 40 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.4407 6.01609L33.2967 1.05209C32.6527 0.532093 31.6967 0.632093 31.1727 1.28009L14.4047 22.0481L7.83665 16.0801C7.22065 15.5161 6.26065 15.5681 5.70065 16.1801L0.392652 22.0201C-0.167348 22.6361 -0.123348 23.5961 0.492652 24.1561L14.5327 36.9201C15.1487 37.4801 16.0767 37.4081 16.6007 36.7601L21.5527 30.5841C21.5607 30.5761 21.5607 30.5641 21.5687 30.5481L39.6687 8.14009C40.1887 7.49609 40.0847 6.53609 39.4407 6.01609Z",
    fill: "#11A75C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresent);
export default __webpack_public_path__ + "static/media/present.1837e93cc60f4752c9655d37c9082eac.svg";
export { ForwardRef as ReactComponent };